<template>
  <div class="bottom-wrap w-full flex flex-row items-center gap-3 bg-white text-center">
    <div class="" @click="onShowConnectTypeClick">
      <div class="relative">
        <div class="bt-nfc-icon-size">
          <van-image :src="currentIcon"/>
        </div>

        <div v-if="isBrandUser" class="rb-triangle absolute right-1.5 bottom-1.5"></div>
      </div>
    </div>

    <div class="flex flex-row items-center flex-1 gap-3" >
      <template v-if="isBrandUser">
        <button :disabled="disabled" @click="onReadClick" class="flex-1  read-write-btn"
            :style="disableButtonStyle">Read
        </button>
        <button :disabled="disabled" @click="onWriteClick" class="flex-1  read-write-btn"
            :style="disableButtonStyle">Write
        </button>
      </template>
      <template v-else>
        <button :disabled="disabled" @click="onReadClick" class="flex-1  connect-btn"
            :style="disableConnectButtonStyle">Connect
        </button>
      </template>
    </div>

    <transition name="slide-fade" v-if="isBrandUser">
      <div class="head-menu-show" v-if="showConnectType">
        <div class="menu-wrap gap-4">
          <div class="bt-nfc-icon-size" @click="onFuncTypeChange(1)">
            <van-image class="menu-item" :src="btIcon" />
          </div>
          <div class="bt-nfc-icon-size" @click="onFuncTypeChange(2)">
            <van-image class="menu-item" :src="nfcIcon" />
          </div>
        </div>
        <div class="triangle">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import userMixin from "@/mixins/userMixin";

export default {
  name: "BottomOperate",
  mixins:[userMixin],
  props: {
    funcType: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showConnectType: false,
      btIcon: require("@/assets/icons/v2/icon_fn_bluetooth.svg"),
      nfcIcon: require("@/assets/icons/v2/icon_fn_nfc.svg")
    };
  },
  methods: {
    onShowConnectTypeClick() {
      if (!this.showConnectType) {
        this.showConnectType = true;
      }
    },
    onFuncTypeChange(e) {
      this.$emit('onFuncTypeChange',e)
      this.showConnectType = false;
    },

    click_allFunction_side(e) {
      if (e.target.className !== "bt-nfc-icon-size" && e.target.className !== "van-image__img") {
        this.showConnectType = false;
        e.stopPropagation();
      }
    },

    onReadClick() {
      this.$emit("onRead");
    },
    onWriteClick() {
      this.$emit("onWrite");
    }
  },
  watch: {
    showConnectType(newVal, oldVal) {
      if (newVal) {
        document.addEventListener("click", this.click_allFunction_side, true);
        document.addEventListener("scroll", this.click_allFunction_side, true);
      } else {
        if (document.removeEventListener) {
          document.removeEventListener(
              "click",
              this.click_allFunction_side,
              true
          );
          document.removeEventListener(
              "scroll",
              this.click_allFunction_side,
              true
          );
        } else if (document.detachEvent) {
          document.detachEvent("click", this.click_allFunction_side, true);
          document.detachEvent("scroll", this.click_allFunction_side, true);
        }
      }
    }
  },
  computed: {
    ...mapState("bluetooth", ["isConnected"]),
    btConnectedClasses() {
      if (this.funcType === 1 && this.isConnected) {
        return 'bt-device-connected'
      }
    },
    disableButtonStyle() {
      return {
        color: this.disabled ? "#8E8E8E" : "#333333"
      };
    },
    disableConnectButtonStyle() {
      return {
        color: this.disabled ? "#8E8E8E" : "white"
      };
    },
    currentIcon() {
      if (this.funcType === 1) {
        return this.btIcon
      }
      return this.nfcIcon
    }
  }
};
</script>

<style scoped lang="less">
.bottom-wrap {
  font-size: 24px;
  padding: 0 16px;
  height: calc(70px + env(safe-area-inset-bottom));
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.head-menu-show {
  position: absolute;
  left: 26px;
  bottom: calc(70px + env(safe-area-inset-bottom) - 8px - 24px);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;


  .menu-wrap {
    box-shadow: 0 0 calc(70px + env(safe-area-inset-bottom)) 0 rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px;
    margin: -5px 0 0 -15px;
    border-radius: 10px;

    .menu-item {
      display: flex;
      align-items: center;

      &:first-child {
        margin-top: 0
      }
    }
  }
}

.bt-nfc-icon-size {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid #BEBEBE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.triangle {
  width: 0;
  height: 0;
  border-top: 20px solid white;
  border-right: 17px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 17px solid transparent;
  z-index: 2;
}

.rb-triangle {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 6px solid black;
  border-bottom: 0px solid transparent;
  border-left: 0px solid transparent;
  z-index: 2;
}

.read-write-btn {
  height: 48px;
  line-height: 48px;
  font-weight: normal;
  font-size:16px;
  font-weight: 600;
  border: 1px solid #BEBEBE;
  border-radius: 12px;
}
.connect-btn{
  line-height: 48px;
  font-weight: normal;
  font-size:16px;
  font-weight: 600;
  height:48px;
  background: #333333;
  color: white;
}
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}

.bt-device-connected {
  color: #679AFF;
}
</style>